// src/json/servicesOverview.json
export const servicesOverviewLeakInvestigationAndRemediation = {
    eyebrow: "OUR LEAK INVESTIGATION & REMEDIATION",
    titleHighlight: "SERVICES INCLUDE:",
    items: [
        {
            title: "Advanced Leak Detection",
            description: "Utilizing thermal imaging, moisture meters, and pressure testing to locate hidden leaks in walls, roofs, balconies, and building envelopes."
        },
        {
            title: "Building Envelope Assessments",
            description: "Evaluating the integrity of exterior walls, windows, caulking, and waterproofing membranes to pinpoint vulnerabilities."
        },
        {
            title: "Targeted Repairs & Waterproofing",
            description: "Applying sealants, coatings, and structural reinforcements to stop water intrusion and prevent future damage."
        },
        {
            title: "Flashing & Sealant Replacement",
            description: "Installing high-quality flashing and reapplying caulking to reinforce weak points and improve water resistance."
        },
        {
            title: "Drainage System Repairs",
            description: "Ensuring proper water flow and drainage to reduce pooling, leaks, and long-term structural damage."
        }
    ],
    imageUrl: "/assets/imgs/services/10LeakInvestigationAndRemediation/servicesOverview/fondo.jpg",
    button: {
        text: "Request a Quote",
        url: "/quote"
    }
};  